<div class="w-full h-full flex flex-col gap-4">
    <div class="w-full flex items-center justify-between gap-2">
        <div class="flex items-center justify-start gap-2">
            <h2 class="oswald-font text-3xl text-nside-orange-400">
                Record of Distribution
            </h2>
            <!-- <div data-popover-target="record-of-distribution-popover-right" data-popover-placement="right" type="button">
                <lucide-icon [name]="icons.CircleHelp" [size]=18 class="text-red-500"></lucide-icon>
            </div>
            <div data-popover id="record-of-distribution-popover-right" role="tooltip" class="absolute z-10 invisible inline-block max-w-96 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">
                <div class="px-3 py-2">
                    <p>
                        This is the Record of Distribution section of the EOP. 
                    </p>
                </div>
                <div data-popper-arrow></div>
            </div>  -->
        </div>
        <div class="flex items-center justify-center gap-2 h-full">
            <div class="h-full relative">
                <!-- Button -->
                <button id="schoolYearDropdownButton" type="button"
                    class="flex items-center justify-center gap-2 px-2 h-full rounded-md border border-gray-300 bg-gray-50 whitespace-nowrap"
                    (click)="$event.preventDefault(); toggleSchoolYearDropdown()">
                    {{ selectedSchoolYear }}
                    <svg class="w-2.5 h-2.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 4 4 4-4" />
                    </svg>
                </button>
    
                <!-- Dropdown list -->
                <div id="schoolYearDropdown" *ngIf="isSchoolYearDropdownOpen"
                    class="absolute top-full mt-1 z-20 divide-y divide-gray-300 bg-orange-50 rounded-md w-full shadow-md">
                    <ul class="py-2">
                        <li *ngFor="let year of schoolYears">
                            <a href="#" class="block px-4 py-2 hover:bg-white hover:text-nside-orange-400"
                                (click)="$event.preventDefault(); handleSchoolYearSelect(year);">
                                {{ year }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <button 
                *ngIf="canSave()"
                (click)="$event.preventDefault(); openSendEOPModal();"
                class="flex flex-row gap-2 items-center justify-center px-4 h-full rounded-md bg-gradient-to-b from-nside-orange-300 to-nside-orange-400  hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200 text-white text-sm"
            >  
                <lucide-icon [name]="icons.Mail" [size]="24"></lucide-icon>
                Send EOP
            </button>
        </div>
    </div>
    <div class="w-full text-sm">
        <p>The record of distribution keeps track of date sending EOP and receiver's email.</p>
    </div>
    <div class="pb-2 w-full h-full flex flex-col items-center gap-2 overflow-y-auto">
        <ng-container *ngIf="recordOfDistribution.length > 0; else emptyRecordOfDistribution">
            <table class="w-full text-left">
                <thead class="oswald-font text-gray-700 uppercase bg-main-background">
                    <tr>
                        <th scope="col" class="p-4">No.</th>
                        <th scope="col" class="p-4">Date Sent</th>
                        <th scope="col" class="p-4">Receiver(s)</th>
                        <th scope="col" class="p-4">Sent By</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of recordOfDistribution | paginate: { itemsPerPage: itemsPerPage, currentPage: page }; let i = index" class="bg-white border-b">
                        <th scope="row" class="p-4 font-medium text-gray-900 whitespace-nowrap">
                            {{ i + 1 }}
                        </th>
                        <td class="p-4">{{ record.date_sent | date: 'MM/dd/yyyy - HH:mm' }}</td>
                        <td class="p-4">{{ record.receiver_emails.join(', ') }}</td>
                        <td class="p-4">{{ record.user_name_sent }}</td>
                    </tr>
                </tbody>
            </table>
            <div class="w-full flex justify-between items-center">
                <p class="w-full">{{ recordOfDistribution.length }} in total</p>
                <pagination-controls
                    *ngIf="recordOfDistribution.length > itemsPerPage" 
                    (pageChange)="page = $event"
                    previousLabel="Prev"
                    nextLabel="Next"
                    class="mt-2"
                ></pagination-controls>
            </div>
        </ng-container>
        <ng-template #emptyRecordOfDistribution>
            <div class="w-full text-nside-gray-100 italic">
                Empty Record
            </div>
        </ng-template>
    </div>
</div>

<!-- Send EOP MODAL -->
<div 
    *ngIf="displaySendEOPModal" (click)="$event.preventDefault(); closeSendEOPModal();"
    class="fixed inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-20"
>
    <div class="bg-white p-6 w-1/3 xl:w-1/4 rounded-md shadow-lg text-center" (click)="$event.stopPropagation()">
        <form  
            (ngSubmit)="sendEOP()"
            class="w-full flex flex-col items-center justify-center gap-4"
        >
            <div class="w-full flex items-center justify-between">
                <div class="flex items-center gap-2">
                    <div class="p-2 rounded-full bg-orange-100">
                        <lucide-icon [name]="icons.Mail" [size]="24" class="text-nside-orange-400"></lucide-icon>
                    </div>
                    <h2 class="oswald-font text-xl font-medium text-nside-orange-400 text-start">
                        Send EOP
                    </h2>
                </div>
                <button (click)="$event.preventDefault(); closeSendEOPModal();" type="button">
                    <lucide-icon [name]="icons.X" [size]="20" class="text-nside-gray-200"></lucide-icon>
                </button>
            </div>

            <div class="w-full flex flex-col gap-2">
                <div class="h-full flex gap-2 items-center">
                    <input noEmoji 
                        type="email"
                        [(ngModel)]="newEmail"
                        name="newEmail"
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded block flex-grow p-2"
                        placeholder="E.g., johndoe@example.com"
                    >
                    <button type="button"
                        (click)="$event.preventDefault(); addEmail()"
                        class="w-10 h-10 text-white flex items-center justify-center rounded border bg-gradient-to-b"
                        [ngClass]="{
                            'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': newEmail.trim() === '' || emails.includes(newEmail.trim()),
                            'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': newEmail.trim() !== '' && !emails.includes(newEmail.trim())
                        }"
                        [disabled]="newEmail.trim() === '' || emails.includes(newEmail.trim())"
                    >
                        <lucide-icon [name]="icons.Plus"></lucide-icon>
                    </button>
                </div>

                <div *ngIf="emails.length > 0" class="flex flex-wrap gap-2">
                    <div *ngFor="let email of emails; let i = index" class="px-2 py-1 text-sm bg-orange-100 rounded-full flex items-center gap-1">
                        {{ email }}
                        <button type="button" (click)="$event.preventDefault(); removeEmail(i)">
                            <lucide-icon [name]="icons.X" [size]="14" class="text-nside-orange-400"></lucide-icon>
                        </button>
                    </div>
                </div>
            </div>

            <div class="w-full flex items-center justify-end gap-3">
                <button
                    class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                    (click)="$event.preventDefault(); closeSendEOPModal();"
                >
                    Close
                </button>
                <button
                    type="submit"
                    class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                    [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed': emails.length === 0,
                        'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200': emails.length > 0
                    }"
                    [disabled]="emails.length === 0"
                >Send</button>
            </div>
        </form>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>